/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetrySearchLogs } from "../funcs/telemetrySearchLogs.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SearchLogsResult } from "../models/components/searchlogsresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  SearchLogsRequest,
  SearchLogsSecurity,
} from "../models/operations/searchlogs.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type SearchLogsMutationVariables = {
  request: SearchLogsRequest;
  security?: SearchLogsSecurity | undefined;
  options?: RequestOptions;
};

export type SearchLogsMutationData = SearchLogsResult;

export type SearchLogsMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * searchLogs telemetry
 *
 * @remarks
 * Search and list telemetry logs that match a search filter
 */
export function useSearchLogsMutation(
  options?: MutationHookOptions<
    SearchLogsMutationData,
    SearchLogsMutationError,
    SearchLogsMutationVariables
  >,
): UseMutationResult<
  SearchLogsMutationData,
  SearchLogsMutationError,
  SearchLogsMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildSearchLogsMutation(client, options),
    ...options,
  });
}

export function mutationKeySearchLogs(): MutationKey {
  return ["@gram/client", "telemetry", "searchLogs"];
}

export function buildSearchLogsMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: SearchLogsMutationVariables,
  ) => Promise<SearchLogsMutationData>;
} {
  return {
    mutationKey: mutationKeySearchLogs(),
    mutationFn: function searchLogsMutationFn({
      request,
      security,
      options,
    }): Promise<SearchLogsMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(telemetrySearchLogs(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
